import React, { useState } from 'react';
import './Preprocessing.css';

const Preprocessing = () => {
  const [selectedModel, setSelectedModel] = useState('***select***');
  const [selectedAttribute, setSelectedAttribute] = useState('***select***');
  const [countDataFile, setCountDataFile] = useState(null);
  const [metaDataFile, setMetaDataFile] = useState(null);
  const [resultDirectory, setResultDirectory] = useState('');
  const [threshold, setThreshold] = useState('20.00');
  const [normalized, setNormalized] = useState('yes');
  const [countMatrixInfo, setCountMatrixInfo] = useState('');
  const [countMatrixAfterFiltering, setCountMatrixAfterFiltering] = useState('');
  const [metaDataText, setMetaDataText] = useState('');

  const handleCountDataBrowse = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCountDataFile(file.name);
    }
  };

  const handleMetaDataBrowse = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMetaDataFile(file.name);
    }
  };

  const handleResultDirectoryBrowse = () => {
    // Placeholder for directory selection
    alert('Directory browser would open here');
  };

  const handleGo = () => {
    // Process data and update summary
    setCountMatrixInfo('Processed count matrix information...');
  };

  const handleApplyThreshold = () => {
    // Apply threshold filtering
    setCountMatrixAfterFiltering('Filtered count matrix information...');
  };

  const handleApplyNormalization = () => {
    // Apply TMM normalization
    alert('TMM Normalization applied');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Form submitted');
  };

  const handleSaveMetaData = () => {
    alert('Meta data saved');
  };

  return (
    <main className="preprocessing-page">
      <div className="preprocessing-container">
        {/* Left Form Section */}
        <section className="form-section">
          <form onSubmit={handleSubmit}>
            {/* Model and Attributes Selection */}
            <div className="form-row">
              <div className="form-group">
                <label>Select Model</label>
                <select value={selectedModel} onChange={(e) => setSelectedModel(e.target.value)}>
                  <option>***select***</option>
                  <option>Model 1</option>
                  <option>Model 2</option>
                  <option>Model 3</option>
                </select>
              </div>
              <div className="form-group">
                <label>Attributes</label>
                <select value={selectedAttribute} onChange={(e) => setSelectedAttribute(e.target.value)}>
                  <option>***select***</option>
                  <option>Attribute 1</option>
                  <option>Attribute 2</option>
                  <option>Attribute 3</option>
                </select>
              </div>
            </div>

            {/* File Upload Row */}
            <div className="form-row">
              <div className="form-group">
                <label>Load count data</label>
                <div className="file-input-group">
                  <input type="text" value={countDataFile || ''} readOnly placeholder="No file selected" />
                  <label className="browse-button">
                    Browse
                    <input type="file" onChange={handleCountDataBrowse} style={{ display: 'none' }} />
                  </label>
                </div>
              </div>
              <div className="form-group">
                <label>Load meta data</label>
                <div className="file-input-group">
                  <input type="text" value={metaDataFile || ''} readOnly placeholder="No file selected" />
                  <label className="browse-button">
                    Browse
                    <input type="file" onChange={handleMetaDataBrowse} style={{ display: 'none' }} />
                  </label>
                </div>
              </div>
            </div>

            {/* Result Directory Row */}
            <div className="form-row">
              <div className="form-group full-width">
                <label>Select Result Directory</label>
                <div className="file-input-group">
                  <input type="text" value={resultDirectory} onChange={(e) => setResultDirectory(e.target.value)} placeholder="Select directory..." />
                  <button type="button" className="browse-button" onClick={handleResultDirectoryBrowse}>
                    Browse
                  </button>
                  <button type="button" className="go-button" onClick={handleGo}>
                    Go
                  </button>
                </div>
              </div>
            </div>

            {/* Summary Section */}
            <div className="summary-section">
              <h3>Summary</h3>
              <p className="summary-label">Count matrix contain:</p>
              <textarea 
                className="summary-textarea" 
                value={countMatrixInfo}
                readOnly
                placeholder="Summary information will appear here..."
              />
            </div>

            {/* Edit Meta Data Button */}
            <button type="button" className="edit-meta-button">
              Edit Meta Data
            </button>

            {/* Filtering Section */}
            <div className="filter-section">
              <p className="filter-label">Filter genes with low summarized expression across all conditions</p>
              <div className="threshold-row">
                <label>Threshold</label>
                <input 
                  type="number" 
                  value={threshold} 
                  onChange={(e) => setThreshold(e.target.value)}
                  className="threshold-input"
                />
                <button type="button" className="apply-button" onClick={handleApplyThreshold}>
                  Apply
                </button>
              </div>
            </div>

            {/* Normalization Section */}
            <div className="normalization-section">
              <label>Normalized</label>
              <div className="radio-group">
                <label className="radio-label">
                  <input 
                    type="radio" 
                    value="yes" 
                    checked={normalized === 'yes'} 
                    onChange={(e) => setNormalized(e.target.value)}
                  />
                  Yes
                </label>
                <label className="radio-label">
                  <input 
                    type="radio" 
                    value="no" 
                    checked={normalized === 'no'} 
                    onChange={(e) => setNormalized(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>

            {/* TMM Normalization */}
            <div className="tmm-section">
              <label>Apply TMM Normalization</label>
              <button type="button" className="apply-button" onClick={handleApplyNormalization}>
                Apply
              </button>
            </div>

            {/* Summary After Filtering */}
            <div className="summary-section">
              <h3>Summary</h3>
              <p className="summary-label">Count matrix after filtering</p>
              <textarea 
                className="summary-textarea" 
                value={countMatrixAfterFiltering}
                readOnly
                placeholder="Filtered summary will appear here..."
              />
            </div>

            {/* Submit Button */}
            <button type="submit" className="submit-button">
              Submit
            </button>
          </form>
        </section>

        {/* Right Meta Data Panel */}
        <aside className="meta-data-panel">
          <h2>Update meta data</h2>
          <textarea 
            className="meta-data-textarea"
            value={metaDataText}
            onChange={(e) => setMetaDataText(e.target.value)}
            placeholder="Enter meta data here..."
          />
          <button type="button" className="save-button" onClick={handleSaveMetaData}>
            Save
          </button>
        </aside>
      </div>
    </main>
  );
};

export default Preprocessing;